"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const AdAnalyticsMedia_1 = require("../AdAnalyticsPlacementTypes/AdAnalyticsMedia");
const AdAnalyticsPlacement_1 = require("../AdAnalyticsPlacementTypes/AdAnalyticsPlacement");
const AdAnalyticsPlatform_1 = require("../AdAnalyticsPlacementTypes/AdAnalyticsPlatform");
const User_1 = require("../User");
class AdAnalyticsReport {
    constructor({ id, adVideos, createdAt, createdBy, title, body, period, platforms, medias, placements, }) {
        this.toJSON = () => ({
            id: this.id,
            adVideos: this.adVideos && this.adVideos.toJSON(),
            createdAt: this.createdAt.toISO(),
            createdBy: this.createdBy && this.createdBy.toJSON(),
            title: this.title,
            body: this.body,
            period: this.period,
            platforms: this.platforms && this.platforms.toJSON(),
            medias: this.medias && this.medias.toJSON(),
            placements: this.placements && this.placements.toJSON(),
        });
        this.id = id;
        this.adVideos = adVideos;
        this.createdAt = createdAt;
        this.createdBy = createdBy;
        this.title = title;
        this.body = body;
        this.period = period;
        this.platforms = platforms;
        this.medias = medias;
        this.placements = placements;
    }
}
AdAnalyticsReport.fromJSON = (json) => {
    const { id, adVideos, createdAt, createdBy, title, body, period, platforms, medias, placements } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof title !== 'string')
        throw new Error('.title must be a string');
    if (body !== null && typeof body !== 'string')
        throw new Error('.body must be a string');
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    const _periods = deserializeToperiods(period);
    const _createdBy = User_1.DirectorUser.fromJSON(createdBy);
    if (!Array.isArray(platforms))
        throw new Error('.platforms must be an array');
    if (!Array.isArray(medias))
        throw new Error('.medias must be an array');
    if (!Array.isArray(placements))
        throw new Error('.placements must be an array');
    const _platforms = immutable_1.List(platforms).map((platform) => AdAnalyticsPlatform_1.default.fromJSON(platform));
    const _medias = immutable_1.List(medias).map((media) => AdAnalyticsMedia_1.default.fromJSON(media));
    const _placements = immutable_1.List(placements).map((placement) => AdAnalyticsPlacement_1.default.fromJSON(placement));
    return new AdAnalyticsReport({
        id,
        adVideos: immutable_1.List(adVideos),
        createdAt: luxon_1.DateTime.fromISO(createdAt),
        createdBy: _createdBy,
        title,
        body,
        period: _periods,
        platforms: _platforms,
        medias: _medias,
        placements: _placements,
    });
};
const deserializeToperiods = (str) => {
    if (Object.keys(periods).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(periods).join(', ')}`);
    }
    return str;
};
const periods = {
    lifetime: 'lifetime',
    last_7_days: 'last_7_days',
    last_30_days: 'last_30_days',
    last_week: 'last_week',
    last_month: 'last_month',
};
exports.default = AdAnalyticsReport;
